/**
 * Capitaliza la primera letra de cada palabra en un texto
 * @param {string} text - El texto a capitalizar
 * @returns {string} - El texto con todas las iniciales en mayúscula
 */
export const capitalizeText = (text) => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  return text
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Capitaliza solo la primera letra del texto completo
 * @param {string} text - El texto a capitalizar
 * @returns {string} - El texto con la primera letra en mayúscula
 */
export const capitalizeFirstLetter = (text) => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export default capitalizeText;
